<template>
  <v-card class="px-2 pb-2 mb-3 elevation-0">
    <v-card-title primary-title>
      <span class="title">Fund Transfer</span>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-slide-y-transition mode="out-in">
        <v-form v-model="valid" ref="form" @submit.prevent="submit" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.from"
                  label="From"
                  :items="formAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="fromSearch"
                  prepend-icon="mdi-account"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.to"
                  label="To"
                  :items="formAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="toSearch"
                  prepend-icon="mdi-account"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.currency"
                  label="Currency"
                  :items="formCurrencies"
                  item-text="key"
                  item-value="value"
                  item-disabled="disabled"
                  :search-input.sync="currencySearch"
                  prepend-icon="mdi-currency-btc"
                  :rules="[v => !!v || 'This field is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="model.amount"
                  label="Amount"
                  type="number"
                  prepend-icon="mdi-currency-usd"
                  :rules="[v => v > 0 || 'This field is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn color="primary" style="margin-left: 2.3em" type="submit" :loading="loading" :disabled="loading">Submit</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-slide-y-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import MongoService from '../../services/mongo.service'
  import MessageDialog from '../../libs/message-dialog/'
  // import { sortedUniq } from '../../libs/utils.js'

  export default {
    data () {
      return {
        loading: false,
        valid: true,
        accounts: [],
        model: {
          from: null,
          to: null,
          currency: null,
          amount: 0
        },
        fromSearch: null,
        toSearch: null,
        currencySearch: null,
        result: null
      }
    },
    computed: {
      formAccounts () {
        return Object.keys(this.accounts).map(id => ({ 'key': id, 'value': id }))
      },
      formCurrencies () {
        const fromCurrencies = this.accounts[this.model.from]
        const toCurrencies = this.accounts[this.model.to]
        if (!fromCurrencies || !toCurrencies) return []
        const sameCurrencies = fromCurrencies.filter(currency => toCurrencies.indexOf(currency) >= 0)
        return sameCurrencies
        // return sortedUniq([...fromCurrencies, ...toCurrencies])
          .map(currency => ({ 'key': currency, 'value': currency, 'disabled': sameCurrencies.indexOf(currency) === -1 }))
      }
    },
    watch: {
      'model.from' (v) {
        if (v === this.model.to) {
          this.model.to = null
        }
      },
      'model.to' (v) {
        if (v === this.model.from) {
          this.model.from = null
        }
      }
    },
    async beforeMount () {
      this.loading = true
      try {
        this.accounts = await MongoService.fund.accountCurrencies()
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    methods: {
      async submit () {
        if (!this.$refs.form.validate()) return
        this.loading = true
        this.result = null
        const { from, to, currency, amount } = this.model
        try {
          const result = await MongoService.fund.transfer(from, to, currency, amount)
          if (result) {
            MessageDialog.showSuccessMessage({
              html: `
                <div>Your request has been processed</div>
                <code class="mt-3 pl-3 pr-3 text-xs-left"><pre>${JSON.stringify({ from, to, currency, amount }, null, 2)}</pre></code>
              `
            })
          }
          this.result = result
        } catch (e) {
          MessageDialog.showErrorMessage({ text: e.toString() })
          console.error(e)
        }
        this.loading = false
      }
    }
  }
</script>
